import { Form } from '@models/Form'
import { APIResponse } from '@supplement-bacon/react-toolkit/models'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { FORM_URL } from '@utils/urls'

const fetchForms = (params: TableParams) =>
  SBAPI.FetchPaginated<Form[]>(FORM_URL, params)

const fetchFormById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<Form>(`${FORM_URL}/${id}`, params)

const createForm = (form: Form) =>
  SBAPI.Post<Form, APIResponse<{ message: number }>>(FORM_URL, form)

const updateForm = (form: Form) => SBAPI.Put(`${FORM_URL}/${form.id}`, form)

const deleteForm = (form: Form) => SBAPI.Delete(`${FORM_URL}/${form.id}`)

export { createForm, deleteForm, fetchFormById, fetchForms, updateForm }
